import { FC, useContext } from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { SliderDraggingContext } from "./Slider";

export type ScrollCardProps = {
  onClick?: (visability: any) => void;
  itemId: string;
  className?: string;
};
export const ScrollCard: FC<ScrollCardProps> = ({
  onClick,
  children,
  itemId,
  className
}) => {
  const visibility = useContext(VisibilityContext);
  const {dragging} = useContext(SliderDraggingContext)
  return (
    <div
    className={className}
      onClickCapture={(e) => {
        if(dragging){

          e.stopPropagation()
          e.preventDefault()
        }

      }}
      style={{
        marginRight: "26px",
        marginLeft: '26px',
        // width: "473px",
        userSelect: "none",
        marginBottom: '10px',
        outline: 'none'
      }}
      tabIndex={0}
    >
      
      {children}
    </div>
  );
};
